// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.black-color {
  color: #1A1A18;
}

.title {
  cursor: pointer;
  position: relative;
  margin: 0;
  font-family: AppFontBold, sans-serif;
  font-size: 13px;
  line-height: 16px;
  text-align: left;
  text-transform: capitalize;
  color: #1A1A18;
}

.name {
  font-family: AppFontBold, sans-serif;
  font-size: 12px;
  line-height: 15px;
  color: #1A1A18;
  text-align: left;
  padding: 15px 0px;
}

p {
  padding: 15px 0px;
  text-align: left;
  font-family: AppFont, sans-serif;
  font-size: 11.5px;
  line-height: 20px;
  color: #1A1A18 !important;
}

div {
  position: relative;
  transition: max-height linear 0.3s;
}

.active {
  max-height: -moz-fit-content;
  max-height: fit-content;
  overflow: hidden;
}

.inactive {
  max-height: 0;
  overflow: hidden;
}

.nutrition-name {
  font-size: 10px;
  text-align: left;
  color: #1A1A18;
  padding-left: 20px;
}

.nutrition-value {
  text-align: right;
  color: #1A1A18;
  font-size: 10px;
  padding-right: 20px;
}

.border-top {
  border-top: 1px solid #dcdddc;
}

.allergens_title {
  font-family: AppFont, sans-serif;
  font-size: 16px;
  color: var(--ion-color-black);
}

ul {
  margin: 0px;
  padding: 0px 30px;
}
ul li {
  font-size: 10px;
  text-align: left;
  color: #1A1A18 !important;
  padding: 6px 0px;
}

span {
  color: var(--ion-color-black);
}

.padding-top {
  padding-top: 15px;
}

label {
  font-size: 10px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/allergens-info/allergens-info.component.scss"],"names":[],"mappings":"AACA;EACE,cAAA;AAAF;;AAGA;EACE,eAAA;EACA,kBAAA;EACA,SAAA;EAGA,oCAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,0BAAA;EACA,cAAA;AAFF;;AAKA;EACE,oCAAA;EACA,eAAA;EACA,iBAAA;EAEA,cAAA;EACA,gBAAA;EACA,iBAAA;AAHF;;AAMA;EACE,iBAAA;EACA,gBAAA;EACA,gCAAA;EACA,iBAAA;EACA,iBAAA;EAEA,yBAAA;AAJF;;AAOA;EACE,kBAAA;EACA,kCAAA;AAJF;;AAQA;EACE,4BAAA;EAAA,uBAAA;EACA,gBAAA;AALF;;AAQA;EACE,aAAA;EACA,gBAAA;AALF;;AAOA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AAJF;;AAMA;EACE,iBAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;AAHF;;AAKA;EACE,6BAAA;AAFF;;AAIA;EACE,gCAAA;EACA,eAAA;EACA,6BAAA;AADF;;AAGA;EACE,WAAA;EAEA,iBAAA;AADF;AAEE;EACE,eAAA;EACA,gBAAA;EACA,yBAAA;EAEA,gBAAA;AADJ;;AAIA;EACE,6BAAA;AADF;;AAGA;EACE,iBAAA;AAAF;;AAGA;EACE,eAAA;AAAF","sourcesContent":["\n.black-color {\n  color: #1A1A18;\n\n}\n.title {\n  cursor: pointer;\n  position: relative;\n  margin: 0;\n\n\n  font-family: AppFontBold, sans-serif;\n  font-size: 13px;\n  line-height: 16px;\n  text-align: left;\n  text-transform: capitalize;\n  color: #1A1A18;\n}\n\n.name {\n  font-family: AppFontBold, sans-serif;\n  font-size: 12px;\n  line-height: 15px;\n\n  color: #1A1A18;\n  text-align: left;\n  padding: 15px 0px;\n}\n\np {\n  padding: 15px 0px;\n  text-align: left;\n  font-family: AppFont, sans-serif;\n  font-size: 11.5px;\n  line-height: 20px;\n\n  color: #1A1A18 !important;\n}\n\ndiv {\n  position: relative;\n  transition: max-height linear 0.3s;\n\n}\n\n.active {\n  max-height: fit-content;\n  overflow: hidden;\n}\n\n.inactive {\n  max-height: 0;\n  overflow: hidden;\n}\n.nutrition-name {\n  font-size: 10px;\n  text-align: left;\n  color: #1A1A18;\n  padding-left: 20px;\n}\n.nutrition-value {\n  text-align: right;\n  color: #1A1A18;\n  font-size: 10px;\n  padding-right: 20px;\n}\n.border-top {\n  border-top: 1px solid #dcdddc;\n}\n.allergens_title {\n  font-family: AppFont, sans-serif;\n  font-size: 16px;\n  color: var(--ion-color-black);\n}\nul {\n  margin: 0px;\n  // list-style-type: none;\n  padding: 0px 30px;\n  li {\n    font-size: 10px;\n    text-align: left;\n    color: #1A1A18 !important;\n\n    padding: 6px 0px;\n  }\n}\nspan {\n  color: var(--ion-color-black);\n}\n.padding-top {\n  padding-top: 15px;\n}\n\nlabel {\n  font-size: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
